export enum LoginRouteName {
  Login = 'login',
}
